/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const InterfaceHeart01 = ({ className }) => {
  return (
    <svg
      className={`interface-heart-01 ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 25 24"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M12.75 7.69428C10.75 2.99984 3.75 3.49984 3.75 9.49987C3.75 15.4999 12.75 20.5001 12.75 20.5001C12.75 20.5001 21.75 15.4999 21.75 9.49987C21.75 3.49984 14.75 2.99984 12.75 7.69428Z"
        stroke="#6957DA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};
